import React, { useCallback, useEffect, useMemo, useState } from 'react'

import { useAppDispatch } from '@/hooks/redux'
import { FORM_FIELDS } from '@/pages/getRecipe/microLayering/materialAdvice/utils/formTypes'
import { useAppSelector } from '@/store'
import { removeFrameWorkIndex } from '@/store/appSlice'
import { resetFrameworkRecipeState } from '@/store/microLayering'
import { Workflows, showPrepColorPicker } from '@/utils/constants'

import MaterialAdviceTooltip from './components/MatrialAdviceTooltip'

const KonvaMaterialAdvice = () => {
  const dispatch = useAppDispatch()
  const materialAdviceOuput = useAppSelector(
    (state) => state.microLayering.materialAdviceOuput,
  )

  const targetColor = useAppSelector(
    (state) => state.microLayering.materialTargetColor,
  )

  const indication = useAppSelector(
    (state) => state?.microLayering.materialAdviceForm[FORM_FIELDS.INDICATION],
  )

  const canvasImage = useAppSelector((state) => state.app.canvasImage)

  const [tooltipOpen, setTooltipOpen] = useState(true)
  const [lockedPosition, setLockedPosition] = useState<{
    x: number
    y: number
  } | null>(null)
  const [prevOutputJson, setPrevOutputJson] = useState<string>('')

  const outputData = materialAdviceOuput?.[canvasImage?.id]
  const colorData = targetColor

  const shouldUseIncisal = useMemo(
    () => showPrepColorPicker.includes(indication),
    [indication],
  )

  const regionKey =
    shouldUseIncisal && colorData?.INCISAL?.imagePosition ? 'INCISAL' : 'MIDDLE'

  const regionData = colorData?.[regionKey]?.imagePosition

  useEffect(() => {
    const currentOutputJson = JSON.stringify(outputData)

    if (outputData && currentOutputJson !== prevOutputJson && regionData) {
      setLockedPosition(regionData)
      setPrevOutputJson(currentOutputJson)
    }
  }, [outputData, regionData, prevOutputJson])

  const handleToggleTooltip = useCallback(() => {
    setTooltipOpen((prev) => !prev)
  }, [])

  const handleCloseTooltip = useCallback(() => {
    setTooltipOpen(false)
  }, [])

  const handleDeleteFramework = useCallback(() => {
    if (!canvasImage?.id) return

    dispatch(resetFrameworkRecipeState({ imageId: canvasImage.id }))
    dispatch(
      removeFrameWorkIndex({
        workflow: Workflows.MICRO_LAYERING,
        imageId: canvasImage.id,
      }),
    )
  }, [dispatch, canvasImage?.id])

  if (!outputData || !lockedPosition) return null

  return (
    <MaterialAdviceTooltip
      key={regionKey}
      keyName={regionKey}
      data={lockedPosition}
      output={outputData}
      open={tooltipOpen}
      toggle={handleToggleTooltip}
      close={handleCloseTooltip}
      workflow={Workflows?.MICRO_LAYERING}
      onDelete={handleDeleteFramework}
    />
  )
}

export default KonvaMaterialAdvice
